import { useCallback, useMemo, useState } from "react";
import { useScrollTrigger, useTheme } from "@material-ui/core";
import { createStyles, makeStyles } from "@material-ui/core/styles";
import { Theme } from "@material-ui/core";
import { useAtomicStyles } from "styles";
import { useTypedTranslations } from "hooks";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    rootContainer: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-between",
    },
    menuIcon: {
      color: "#fff",
    },
    link: {
      marginRight: 20,
      fontSize: "1.1rem",
      color: "#fff",
      textDecoration: "none",
      "&:hover": {
        textDecoration: "underline",
        cursor: "pointer",
      },
    },
    logoContainer: {
      marginRight: "auto",
      maxWidth: 160,
      [theme.breakpoints.down("md")]: {
        maxWidth: "20vw",
      },
    },
    logo: {
      marginRight: "auto",
      maxWidth: 160,
      "&:hover": {
        cursor: "pointer",
      },
      [theme.breakpoints.down("md")]: {
        maxWidth: 100,
      },
    },
    paper: {
      background: "#673368",
      color: "white",
    },
  }),
);

const useHeader = () => {
  const theme = useTheme();
  const styles = useStyles(theme);
  const classes = useMemo(
    () => ({
      swipeableDrawerMenu: {
        paper: styles.paper,
      },
    }),
    [styles],
  );
  const atomicStyles = useAtomicStyles();
  const [isSwipeableDrawerOpen, setIsSwipeableDrawerOpen] = useState(false);
  const handleSwipeableDrawerOpen = useCallback(
    () => setIsSwipeableDrawerOpen(true),
    [],
  );
  const handleSwipeableDrawerClose = useCallback(
    () => setIsSwipeableDrawerOpen(false),
    [],
  );
  const trigger = useScrollTrigger();
  const [t] = useTypedTranslations();

  const handleGoToSection = useCallback((section) => {
    switch (section) {
      case "home": {
        document.querySelector(`[data-section=home]`).scrollIntoView({
          behavior: "smooth",
        });
        break;
      }
      case "how": {
        document.querySelector(`[data-section=how-to]`).scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
        break;
      }
      case "prices": {
        document.querySelector(`[data-section=prices]`).scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
        break;
      }
      default: {
        document.querySelector(`[data-section=home]`).scrollIntoView({
          behavior: "smooth",
        });
      }
    }
  }, []);

  const handleDrawerItemSelection = useCallback(
    (section) => {
      setIsSwipeableDrawerOpen(false);
      setTimeout(() => handleGoToSection(section), 500);
    },
    [handleGoToSection],
  );

  return {
    styles,
    classes,
    atomicStyles,
    isSwipeableDrawerOpen,
    handleSwipeableDrawerOpen,
    handleSwipeableDrawerClose,
    handleGoToSection,
    handleDrawerItemSelection,
    trigger,
    t,
  };
};

export { useHeader as default };
